import { httpPost, httpGet, httpPut, httpDelete } from "./request";

export const queryDomain = (data: any) => {
  return httpGet({
    url: "/ikg/domain/query",
    data,
  });
};

export const insertDomain = (data: any) => {
  return httpPost({
    url: "/ikg/domain/insert",
    data,
  });
};

export const queryVersion = (data: any) => {
  return httpGet({
    url: "/ikg/dict/version/query",
    data,
  });
};

export const queryDirectory = (data: any) => {
  return httpGet({
    url: "/ikg/dict/directory/query",
    data,
  });
};

export const insertDirectory = (data: any) => {
  return httpPost({
    url: "/ikg/dict/directory/insert",
    data,
  });
};

export const deleteDirectory = (data: any) => {
  return httpDelete({
    url: "/ikg/dict/directory/delete",
    data,
  });
};

export const updateDirectory = (data: any) => {
  return httpPut({
    url: "/ikg/dict/directory/update",
    data,
  });
};

export const queryDictItems = (data: any) => {
  return httpGet({
    url: "/ikg/dict/item/query",
    data,
  });
};

export const getSourceItems = (data: any) => {
  return httpGet({
    url: "/ikg/dict/item/source",
    data,
  });
};

export const addDictItem = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/add",
    data,
  });
};

export const modifyDictItem = (data: any) => {
  return httpPut({
    url: "/ikg/dict/item/modify",
    data,
  });
};

export const deleteDictItem = (data: any) => {
  return httpPut({
    url: "/ikg/dict/item/delete",
    data,
  });
};

export const unDeleteDictItem = (data: any) => {
  return httpPut({
    url: "/ikg/dict/item/undelete",
    data,
  });
};

export const createDictVersion = (data: any) => {
  return httpPut({
    url: "/ikg/dict/directory/createDictVersion",
    data,
  });
};

export const approveDictItem = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/approve",
    data,
  });
};

export const prePublishVersion = (data: any) => {
  return httpPost({
    url: "/ikg/dict/version/prePublish",
    data,
  });
};

export const publishVersion = (data: any) => {
  return httpPost({
    url: "/ikg/dict/version/publish",
    data,
  });
};

export const insertDict = (data: any) => {
  return httpPost({
    url: "/ikg/dict/insert",
    data,
  });
};

export const insertVersion = (data: any) => {
  return httpPost({
    url: "/ikg/dict/version/insert",
    data,
  });
};

export const queryDictVersion = (data?: any) => {
  return httpGet({
    url: "/ikg/dict/version/queryDict",
    data,
  });
};

export const domainShowRed = (data?: any) => {
  return httpGet({
    url: "/ikg/domain/showRed",
    data,
  });
};

// 引用目录 || 引用词条
export const quoteProject = (data?: any) => {
  return httpPost({
    url: "/ikg/open/project/refence",
    data,
    headers: {
      'Content-Type': 'application/json',
    }
  });
};

export const getDictInfo = (data?: any) => {
  return httpGet({
    url: "/ikg/open/dict/queryInfo",
    data,
  });
};

export const moveDir = (data: any) => {
  return httpPost({
    url: "/ikg/dict/directory/move",
    data,
  });
};

export const moveItem = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/move",
    data,
  });
};

export const mergeDir = (data: any) => {
  return httpPost({
    url: "/ikg/dict/directory/merge",
    data,
  });
};

export const batchApprove = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/approveBatch",
    data,
  });
};

export const dictInsert = (data: any) => {
  return httpPost({
    url: "/ikg/dict/insert",
    data,
  });
};

export const queryStandard = (data: any) => {
  return httpGet({
    url: "/ikg/dataStandard/query/domainAndVersion",
    data,
  });
};

export const knowledgeDir = (data?: any) => {
  return httpGet({
    url: "/ikg/dict/directory/query",
    data,
  });
};

export const addKnowledgeItem = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/add",
    data,
  });
};

export const modifyKnowledgeItem = (data: any) => {
  return httpPut({
    url: "/ikg/dict/item/modify",
    data,
  });
};

export const deleteKnowledgeItem = (data: any) => {
  return httpPut({
    url: "/ikg/dict/item/delete",
    data,
  });
};

export const unDeleteKnowledgeItem = (data: any) => {
  return httpPut({
    url: "/ikg/dict/item/undelete",
    data,
  });
};

export const approveKnowledgeItem = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/approve",
    data,
  });
};

export const batchApproveKnowledgeItem = (data: any) => {
  return httpPost({
    url: "/ikg/dict/item/approveBatch",
    data,
  });
};

export const submitKnowledgeVersion = (data: any) => {
  return httpPut({
    url: "/ikg/dict/directory/createDictVersion",
    data,
  });
};

export const publishKnowledgeVersion = (data: any) => {
  return httpPost({
    url: "/ikg/dict/version/publish",
    data,
  });
};

export const prePublishKnowledgeVersion = (data: any) => {
  return httpPost({
    url: "/ikg/dict/version/prePublish",
    data,
  });
};

export const queryKnowledgeVersion = () => {
  return httpGet({
    url: "/ikg/dict/version/queryDict",
  });
};

export const getKnowledgeItemInstructions = (data: any) => {
  return httpPost({
    url: "/ikg/knowledge/item/instruction",
    data,
  });
};

export const knowledgeDirectoryInsert = (data: any) => {
  return httpPost({
    url: "/ikg/dict/directory/insert",
    data,
  });
};

export const knowledgeUpdateDirectory = (data: any) => {
  return httpPut({
    url: "/ikg/dict/directory/update",
    data,
  });
};

export const knowledgeDeleteDirectory = (data: any) => {
  return httpDelete({
    url: "/ikg/dict/directory/delete",
    data,
  });
};

export const queryMedDRALlt = (data: any, options?: { signal?: AbortSignal }) => {
  return httpGet({
    url: "/ikg/meddra/getDirectory/queryLlt",
    data,
    signal: options?.signal,
  });
};

export const queryWhoDRALlt = (data: any, options?: { signal?: AbortSignal }) => {
  return httpGet({
    url: "/ikg/whodrug/getDirectory/queryByCodeName",
    data: { ...data, ...(data.drugName ? { drugName: encodeURIComponent(data.drugName) } : {}) },
    signal: options?.signal,
  });
};

// -------------------------------- 多文件字典新增版本-----------------------------
/**
 * 
 * @param data 
 * @returns 
 */
export const importMeddra = (dictName, version, data: any) => {
  return httpPost({
    url: `/ikg/meddra/import/importMeddraForUser?version=${version}&dictName=${dictName}`,
    data,
  });
};

export const importOmop = (dictName, version, data: any) => {
  return httpPost({
    url: `/ikg/omop/import/omopForUser?version=${version}&dictName=${dictName}`,
    data,
  });
};

export const importWhoDrugB3 = (dictName, version, data: any) => {
  return httpPost({
    url: `/ikg/whodrug/import/B3?version=${version}&dictName=${dictName}`,
    data,
  });
};

export const importWhoDrugC3 = (dictName, version, data: any) => {
  return httpPost({
    url: `/ikg/whodrug/import/C3?version=${version}&dictName=${dictName}`,
    data,
  });
};


export const addDomain = (data: any) => {
  return httpPost({
    url: "/ikg/domain/insert",
    data,
  });
};

export const addDict = (data: any) => {
  return httpPost({
    url: '/ikg/dict/insert',
    data,
  });
};

export const editDict = (data: any) => {
  return httpPost({
    url: "/ikg/knowledge/updateName",
    data,
    headers: {
      'Content-Type': 'application/json',
    }
  });
};

export const queryFileDirectory = (data: any) => {
  return httpGet({
    url: '/ikg/knowledge/queryFileDirectory',
    data,
  });
};

export const uploadFileDirectory = (data: any, params) => {
  return httpPost({
    url: `/ikg/knowledge/uploadMinio?dictId=${params.dictId}&domainId=${params.domainId}`,
    data,
  });
};

export const deleteKnowledgeFileByDirId = (data: any) => {
  return httpGet({
    url: '/ikg/knowledge/deleteKnowlegeFileByDirId',
    data,
  });
};

export const updateKnowledgeName = (data: any) => {
  return httpGet({
    url: '/ikg/knowledge/updateName',
    data,
  });
};

export const uploadFileJudgeRepeat = (data: any,params) => {
  return httpPost({
    url: `/ikg/knowledge/uploadFileJudgeRepetitione?dictId=${params.dictId}`,
    data,
  });
};

export const downloadFile = (data: any) => {
  return httpPost({
    url: `/ikg/knowledge/downloadFile`,
    data,
    responseType:'blob'
  });
};